import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

import {AlertTitle} from '@chakra-ui/react';

import {AlertIcon} from '@amblique/king-living/app/components/icons';
import {ProductList as ProductListComponent} from '@amblique/king-living/app/components/product-list';
import {usePageContext} from '@amblique/king-living/app/hooks/contentful';
import {usePixleeScript} from '@amblique/king-living/app/hooks/use-pixlee-script';
import Alert from '@amblique/king-living/app/theme/components/base/alert';

/**
 * ProductListing component
 *
 * @param {Object} props - Component props
 * @param {Contentful.ProductListing} props.component - ProductListing component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const ProductListing = ({component, isComplete = true, isFetching = false, ...props}) => {
  const {
    isEdit,
    isCategoryPage,

    productSearchResult,
    isProductSearchLoading,
    isProductSearchFetched,
    isProductSearchRefetching,
    category,
    categoryError,
  } = usePageContext();

  // Load Pixlee script for UGC widgets on product pages
  usePixleeScript();

  return (
    isCategoryPage ? (
      <ProductListComponent
        category={category}
        error={categoryError}
        isFetched={isProductSearchFetched}
        isLoading={isProductSearchLoading}
        isRefetching={isProductSearchRefetching}
        productSearchResult={productSearchResult}
      />
    ) : isEdit ? (
      <Alert status="warning">
        <AlertIcon />
        <AlertTitle>Product Listing - Dynamic</AlertTitle>

        <FormattedMessage
          defaultMessage="This component can only be added to '{aspectType}' pages."
          id="contentful.error.invalid_aspects"
          values={{aspectType: 'Product Listing'}}
        />
      </Alert>
    ) : null
  );
};

ProductListing.displayName = 'ProductListing';
ProductListing.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
